import React, { useEffect, useState } from "react"
import { Button, Col, Container, Form, Image } from "react-bootstrap"
import {
    boardNames,
    colorsNames,
    deliveryNames,
    dimensionsNames,
    personalDataNames,
    typeOptionsNames
} from "../helpers/enums"
import {
    additionalPrices,
    boardOptions,
    colorsOptions,
    dimensionsOptions,
    formsOfDelivery,
    typeOptions
} from "../variables"
import styles from "./Configurator.module.scss"
import {
    defaultOtherColorHex,
    defaultPrice,
    formatPrice,
    HEX_PALETTE_WITHOUT_BASICS,
    isDimensionValid,
    isHigh,
    toHexWithoutError,
    toRalWithoutError
} from "../helpers/functions"
import StepLabel from "./StepLabel/StepLabel"
import PersonalDataForm from "./PersonalDataForm"
import { sendEmail } from "../services/services"
import SendingMessageModal from "./modals/SendingMessageModal"
import { withRouter } from "react-router-dom"

const Configurator = ({contentHeight}) => {

    const initFieldsValidation = {
        [dimensionsNames.HEIGHT]: true,
        [dimensionsNames.LENGTH]: true,
        [dimensionsNames.WIDTH]: true,
        [dimensionsNames.TILT_ANGLE]: true,
    }

    const defaultDimensions = dimensionsOptions.reduce((obj, dim) => ({...obj, [dim.key]: dim.defaultValue}), {})
    // const initColor = toHexWithoutError(6019)
    const initColor = ""

    const [holderType, setHolderType] = useState(typeOptionsNames.TYPE_P)
    const [dimensions, setDimensions] = useState(defaultDimensions)
    const [fieldsValidation, setFieldValidation] = useState(initFieldsValidation)
    const [lampHolder, setLampHolder] = useState(false)
    const [basicColor, setBasicColor] = useState(initColor)
    const [customColor, setCustomColor] = useState(toHexWithoutError(1000))
    const [board, setBoard] = useState(boardNames.BIG)
    const [spareFoil, setSpareFoil] = useState(false)
    const [price, setPrice] = useState(defaultPrice(holderType, board))
    const [isAccepted, setAcceptation] = useState(false)
    const [selectedFormOfDelivery, setSelectedFormOfDelivery] = useState(deliveryNames.PERSONAL_PICKUP)
    const [previewImage, setPreviewImage] = useState(require("../assets/previews/typeP_low.png"))
    const [personalData, setPersonalData] = useState({})
    const [comments, setComments] = useState("")
    const [messageToDisplay, setMessageToDisplay] = useState("")
    const [isSendingMessageModalVisible, setSendingMessageModalVisibility] = useState(false)

    const isColorSelected = basicColor !== initColor && customColor !== defaultOtherColorHex
    const selectedColor = basicColor !== defaultOtherColorHex ? basicColor : customColor
    const selectedColorWithLabel = basicColor !== defaultOtherColorHex ? "Podstawowy: " + toRalWithoutError(basicColor) : "Własny: " + toRalWithoutError(customColor)
    const priceWithDelivery = `${formatPrice(price)}
                    + ${formatPrice(formsOfDelivery.find(option => option.key === selectedFormOfDelivery).price)} koszt wysyłki`

    const allDataToSend = {
        holderType: typeOptions.find(option => option.key === holderType).label,
        ...dimensions,
        lampHolder: lampHolder ? "TAK" : "NIE",
        color: isColorSelected ? selectedColorWithLabel : "nie wybrano",
        board: boardOptions.find(b => b.key === board).label,
        spareFoil: spareFoil ? "TAK" : "NIE",
        delivery: formsOfDelivery.find(formOfDelivery => formOfDelivery.key === selectedFormOfDelivery).label,
        ...personalData,
        comments,
        isAccepted: isAccepted ? "TAK" : "NIE",
        price: priceWithDelivery
    }

    const isHeightValid = () => isDimensionValid(dimensionsOptions.find(dimension => dimension.key === dimensionsNames.HEIGHT), dimensions)

    useEffect(() => {
        let currentPrice = defaultPrice(holderType, board)
        if (isHeightValid() && isHigh(dimensions)) {
            currentPrice += additionalPrices.height
        }
        if (lampHolder) {
            currentPrice += additionalPrices.lampHolder
        }
        if (basicColor === defaultOtherColorHex) {
            currentPrice += additionalPrices.customColor
        }
        if (spareFoil) {
            currentPrice += additionalPrices.spareFoil
        }
        setPrice(currentPrice)
    }, [holderType, dimensions[dimensionsNames.HEIGHT], lampHolder, basicColor, board, spareFoil])

    useEffect(() => {
        const highLowString = isHigh(dimensions) ? "_high" : "_low"
        const lampString = lampHolder ? "_lamp" : ""

        setPreviewImage(
            isHeightValid()
                ? (require(`./../assets/previews/${holderType}${highLowString}${lampString}.png`))
                : (require(`./../assets/previews/no_preview.png`))
        )
    }, [holderType, dimensions[dimensionsNames.HEIGHT], lampHolder])

    useEffect(() => {

    }, [holderType])

    useEffect(() => {
        if (selectedFormOfDelivery !== deliveryNames.PARCEL_LOCKER) {
            setPersonalData({...personalData, [personalDataNames.PARCEL_LOCKER_NUMBER]: ""})
        }
    }, [selectedFormOfDelivery])

    const handleInputDimensionsChange = (e, dimensionName) => {
        e.persist()
        setDimensions(dimensions => ({...dimensions, [dimensionName]: e.target.value}))
    }

    const handlePersonalDataChange = (e) => {
        e.persist()
        setPersonalData(personalData => ({...personalData, [e.target.name]: e.target.value}))
    }

    const dimensionsFieldsValidation = (e, dimension) => {
        const allowedKeys = ["Backspace", "ArrowLeft", "ArrowRight"]
            .some(item => item === e.key)
        if (!allowedKeys) {
            if (e.target.value > dimension.maxValue) e.preventDefault()
        }
    }

    const validateAllDimensions = async () => {
        const objDimensionsValidation =
            dimensionsOptions.reduce((obj, dimension) => ({
                ...obj,
                [dimension.key]: isDimensionValid(dimension, dimensions)
            }), {})
        setFieldValidation(objDimensionsValidation)
    }

    const sendingDataHandler = async (e) => {
        await validateAllDimensions()
        sendEmail(e, allDataToSend, setMessageToDisplay, setSendingMessageModalVisibility)
    }

    const validateDimension = (dimensionToCheck) => {
        const objDimensionValidation = {
            [dimensionToCheck.key]: isDimensionValid(dimensionToCheck, dimensions)
        }
        setFieldValidation({...fieldsValidation, ...objDimensionValidation})
    }

    const isFormValid = Object.values(fieldsValidation).every(field => field)

    const isColorWhiteOrDefault = selectedColor === "#FFFFFF" || selectedColor === initColor

    return (
        <div className="mb-4 textFont textSmall">
            <Container fluid>

                <Form onSubmit={sendingDataHandler}>

                    <Form.Row>

                        <Form.Group as={Col} md={6}
                                    className="d-flex flex-column justify-content-around align-items-center align-self-center"
                                    style={{
                                        border: `0.15rem solid ${(!isColorWhiteOrDefault) ? selectedColor : "#eee"}`,
                                        borderRadius: "4px"
                                    }}>
                            <h6 className={`mt-3`}>PODGLĄD</h6>
                            <hr className="rounded"></hr>
                            <Image src={previewImage.default} className={`${styles.previewImage}`} alt="preview"/>
                            {isColorSelected &&
                            <Form.Group>
                                <hr className="rounded"></hr>
                                <Form.Label>Wybrany kolor stelaża: {toRalWithoutError(selectedColor)} </Form.Label>
                                <Form.Row style={{
                                    backgroundColor: selectedColor,
                                    height: "2rem",
                                    border: "0.15rem solid #eee"}}
                                          className="d-flex justify-content-center align-items-center">
                                    {selectedColor === "#FFFFFF" ? "Pure white" : ""}</Form.Row>
                            </Form.Group>
                            }
                            <Form.Group>
                                {isColorSelected || <hr className="rounded"></hr>}
                                <p className="font-weight-bold">
                                    {`Szacowana cena: ${formatPrice(price)}`}
                                </p>
                            </Form.Group>
                        </Form.Group>

                        <Form.Group as={Col}>

                            <Form.Group as={Col}>
                                <Form.Text className="text-muted">(*) Pola obowiązkowe</Form.Text>
                                <StepLabel>1. Typ mapnika*</StepLabel>
                                <Form.Row className="d-flex justify-content-around">
                                    {typeOptions.map((typeOption) => (
                                        <div key={typeOption.key}>
                                            <Form.Check label={typeOption.label}
                                                        type="radio"
                                                        name="typeOption"
                                                        id={typeOption.key}
                                                        onChange={() => setHolderType(typeOption.key)}
                                                        defaultChecked={typeOption.key === typeOptionsNames.TYPE_P}/>
                                            <Image className={styles.typeImage} alt={typeOption.key}
                                                   src={typeOption.image.default}/>
                                        </div>
                                    ))}
                                </Form.Row>
                            </Form.Group>

                            <Form.Group as={Col}>
                                <StepLabel>2. Wymiary*</StepLabel>
                                {dimensionsOptions.filter(dim => (!(holderType === typeOptionsNames.TYPE_P && dim.key === dimensionsNames.LENGTH)))
                                    .map(dimension => (
                                    <Form.Group key={dimension.key}>

                                        <Form.Text
                                            className={`${!fieldsValidation[dimension.key] ? styles.invalidMessage : "text-muted"}`}>
                                            {`Wpisz liczbę z zakresu ${dimension.minValue} - ${dimension.maxValue}`}
                                        </Form.Text>

                                        <Form.Row key={dimension.key}
                                                  style={{backgroundColor: "#eee", borderRadius: "4px"}}
                                                  className="d-flex justify-content-center align-items-center">
                                            <Form.Label column className="col-5">{dimension.label}</Form.Label>
                                            <Form.Control
                                                column="true"
                                                id={dimension.key}
                                                className={`col-3 ${fieldsValidation[dimension.key] ? "" : styles.invalidField}`}
                                                required
                                                value={dimensions[dimension.key]}
                                                onKeyDown={(e) => dimensionsFieldsValidation(e, dimension)}
                                                onChange={(e) => handleInputDimensionsChange(e, dimension.key)}
                                                onBlur={() => validateDimension(dimension)}
                                                type="number"
                                                min={dimension.minValue}
                                                max={dimension.maxValue}
                                                placeholder={dimension.defaultValue}/>
                                            <Form.Label column className="col-1">{dimension.unit}</Form.Label>
                                        </Form.Row>

                                    </Form.Group>
                                ))}
                            </Form.Group>

                            <Form.Group as={Col} controlId="formSelectColor">

                                <StepLabel>3. Kolor stelaża*</StepLabel>

                                <Form.Control
                                    required
                                    as="select"
                                    htmlSize={1}
                                    style={{backgroundColor: basicColor !== defaultOtherColorHex ? basicColor : "#fff"}}
                                    onChange={(e) => {
                                        setBasicColor(e.target.value);
                                        e.preventDefault()
                                    }}>
                                    <option
                                        id="selectColor"
                                        key="selectColor"
                                        value={initColor}
                                        style={{backgroundColor: "#fff"}}>
                                        Wybierz kolor...
                                    </option>
                                    {colorsOptions.map(colorOption =>
                                        <option
                                            id={colorOption.key}
                                            key={colorOption.key}
                                            value={toHexWithoutError(colorOption.valueRal)}
                                            style={{backgroundColor: toHexWithoutError(colorOption.valueRal)}}>
                                            {colorOption.label} {colorOption.key === colorsNames.OTHER
                                            ? "(+ " + formatPrice(additionalPrices.customColor) + ")"
                                            : "RAL" + colorOption.valueRal}
                                        </option>
                                    )}
                                </Form.Control>
                            </Form.Group>

                            <Form.Group as={Col} controlId="formCustomColor">

                                {basicColor === defaultOtherColorHex &&
                                <Form.Group>
                                    <Form.Row>
                                        <Form.Label column>Własny kolor: </Form.Label>
                                        <Form.Control
                                            as="select"
                                            className="col-12"
                                            style={{backgroundColor: customColor}}
                                            onChange={(e) => {
                                                setCustomColor(e.target.value)
                                            }}>
                                            {HEX_PALETTE_WITHOUT_BASICS.map((colorHex) => {
                                                return <option
                                                    id={colorHex}
                                                    key={colorHex}
                                                    value={colorHex}
                                                    style={{backgroundColor: colorHex}}>
                                                    {toRalWithoutError(colorHex)}
                                                </option>
                                            })}
                                        </Form.Control>
                                    </Form.Row>
                                    <Form.Text className="text-muted">
                                        {`Wybrany własny kolor: ${toRalWithoutError(customColor)}`}
                                    </Form.Text>
                                </Form.Group>
                                }
                            </Form.Group>

                            <Form.Group as={Col} controlId="radioBoard"
                                        className="d-flex flex-column align-items-start">
                                <StepLabel>4. Blat*</StepLabel>
                                {boardOptions.map(boardOption => (
                                    <Form.Check
                                        key={boardOption.key}
                                        label={`${boardOption.label} ${boardOption.dimension} 
                                        ${boardOption.price > 0 ? ("(+ " +
                                            formatPrice(boardOption.price) + ")") : ""}`}
                                        type="radio"
                                        name="boardOption"
                                        id={boardOption.key}
                                        onChange={() => setBoard(boardOption.key)}
                                        defaultChecked={boardOption.key === boardNames.BIG}/>
                                ))}
                            </Form.Group>

                            <Form.Group as={Col}>
                                <StepLabel>5. Zapasowa folia ochronna na blat</StepLabel>
                                <Form.Check
                                    className="d-flex justify-content-start"
                                    type="switch"
                                    id="additionalFoilSwitch"
                                    label={`Chcę zapasową folię (+ 
                            ${formatPrice(additionalPrices.spareFoil)})`}
                                    onChange={() => setSpareFoil(!spareFoil)}
                                />
                            </Form.Group>

                            <Form.Group as={Col}>
                                <StepLabel>6. Dodatkowy uchwyt na lampkę</StepLabel>
                                <Form.Check
                                    className="d-flex justify-content-start"
                                    type="switch"
                                    id="additionalLampHolderSwitch"
                                    label={`Chcę dodatkowy uchwyt na lampkę (+ ${formatPrice(additionalPrices.lampHolder)})`}
                                    onChange={() => setLampHolder(!lampHolder)}
                                />
                            </Form.Group>

                        </Form.Group>

                    </Form.Row>

                    <hr className="rounded"></hr>

                    <Form.Row>

                        <Form.Group as={Col} md={{span: 6, offset: 6}} controlId="formRadioDelivery" className="py-2"
                                    style={{backgroundColor: "#eee", borderRadius: "4px"}}>
                            <Form.Label className="font-weight-bold">Wysyłka*</Form.Label>
                            {formsOfDelivery.map(delivery => (
                                <Form.Check
                                    key={delivery.key}
                                    label={`${delivery.label} ${formatPrice(delivery.price)}`}
                                    type="radio"
                                    name="deliveryOption"
                                    id={delivery.key}
                                    onChange={() => setSelectedFormOfDelivery(delivery.key)}
                                    defaultChecked={delivery.key === deliveryNames.PERSONAL_PICKUP}
                                />
                            ))}
                        </Form.Group>

                    </Form.Row>

                    <PersonalDataForm selectedFormOfDelivery={selectedFormOfDelivery}
                                      handlePersonalDataChange={handlePersonalDataChange}/>

                    <Form.Group as={Col} md={{span: 6, offset: 6}} className="px-0" controlId="formGridComments">
                        <Form.Label className="font-weight-bold pl-2">Uwagi</Form.Label>
                        <Form.Control as="textarea" rows={3} placeholder="comments..."
                                      onChange={(e) => setComments(e.target.value)}/>
                    </Form.Group>

                    <Form.Group as={Col}
                                md={{span: 6, offset: 6}}
                                id="formGridCheckAccept"
                                className="d-flex flex-column justify-content-around align-items-center align-self-center">
                        <Form.Check type="checkbox"
                                    label="Akceptuję zasady*"
                                    required
                                    onChange={() => setAcceptation(!isAccepted)}/>
                        <Form.Text className="text-muted">* Zgoda obowiązkowa</Form.Text>
                        <p></p>
                        <p className="font-weight-bold">Cena: {priceWithDelivery}
                        </p>
                        <Button
                            type="submit"
                            variant="primary"
                            disabled={!isAccepted}
                        >Wyślij zapytanie</Button>
                    </Form.Group>
                </Form>
            </Container>
            <SendingMessageModal isSendingMessageModalVisible={isSendingMessageModalVisible}
                                 setSendingMessageModalVisibility={setSendingMessageModalVisibility}
                                 messageToDisplay={messageToDisplay}/>
        </div>
    )
}

export default withRouter(Configurator)